import { defineStore } from 'pinia'
import { stateInit }  from './state'
import actions from './actions';
import getters from './getters';

export const usePatient = defineStore('patient', {
  state: stateInit,
  actions,
  getters
});

